import React, { Component } from "react";
import { Link } from "react-router-dom";
import Image from "../../../../base/features/micro/Image";
import checkLength from "../../../../base/utils/check_length";

class CustomProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shopUid: window.location.pathname.split("/")[2],
    };
  }

  render() {
    return (
      <div className="row mx-0 p-0 border rounded14 mb-3">
        <div className="col-12 fw-bolder fs-4 p-3 border-bottom">
          <div className="row mx-0 px-0">
            <div className="col-auto px-1 align-self-center">
              <Image
                imageAlt={"custom-product"}
                extraClassName={"p-1 bg-color-main rounded-circle"}
                imgClassName={"rounded-circle img-cover"}
                imageUri={
                  this.props.product.image && this.props.product.image.thumbnail
                }
                imageHeight={"40"}
                imageWidth={"40"}
              />
            </div>
            <div className="col px-1 align-self-center">
              <p className="fw-bold mb-0 fs-6">
                {checkLength(this.props.product.user.name, 18)}
              </p>
              <p className="fw-bold mb-0 fs-7 text-muted">
                {this.props.product.created}
              </p>
            </div>
            <div className="col-auto px-1 align-self-center">
              <Link
                to={`/dashboard/${this.state.shopUid}/cp/${this.props.product.uid}`}
              >
                <button className="btn px-3 rounded28 border color-main fw-bold fs-6">
                  جزئیات
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div className="col-12 p-3">
          <div className="row mx-0 px-0">
            <div
              className={
                "col-auto align-self-center px-1 fw-bold fs-6 " +
                (this.props.product.status === 1
                  ? "color-main"
                  : this.props.product.status === 2
                  ? "text-danger"
                  : "text-muted")
              }
            >
              {this.props.product.status === 1
                ? "ثبت شده"
                : this.props.product.status === 2
                ? "موافقت نشده"
                : "منتظر تعیین وضعیت"}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomProduct;
